import React from 'react';

import { SalesChannelType } from '@fd/customHooks/useQueryRMSSalesChannels';
import useSearchParams from '@fd/customHooks/useSearchParams';
import { getTranslate } from 'react-localize-redux';
import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom';

import PageLayout from '@fd/ui/Layout';
import LazyComponent from '@fd/ui/LazyComponent';
import Tabs from '@fd/ui/Tabs';

import { lazyWithRetry } from '../../../helpers/utilities';
import { RMSModules } from '../../RMS/utils/rmsModules';
import { RMSSubscriptions } from '../../RMS/utils/rmsSubscriptions';

const RMSPage = lazyWithRetry(() => import('../../RMS/components/RMSPage'));

const SalesChannelList = lazyWithRetry(() => import('../../RMS/SalesChannels/SalesChannelList'));

const MarketPlacesPage = ({ translate, selectedProperty, currentApp }: MappedState) => {
  const searchParams = useSearchParams();
  const rawMarketplaceType = searchParams.get('type');
  // The Just Eat integration URLs use 'JustEat', but the RMS storefront data uses 'JustEats'.
  const marketplaceType =
    rawMarketplaceType === 'JustEat' ? SalesChannelType.JUST_EATS : rawMarketplaceType;
  const history = useHistory();
  const handleChannelClick = (salesChannel) => {
    history.push(
      `/${currentApp?.AppId}/sales-channels/marketplaces/property/${selectedProperty?.code}/sales-channel/${salesChannel.salesChannelId}`
    );
  };
  const tabItems = [
    {
      label: translate('Sales_Channels') as string,
      component: (
        <LazyComponent>
          <SalesChannelList
            filterByType={
              marketplaceType
                ? [marketplaceType as SalesChannelType]
                : [
                    SalesChannelType.JUST_EATS,
                    SalesChannelType.UBER_EATS,
                    SalesChannelType.DELIVEROO,
                  ]
            }
            onChannelClick={handleChannelClick}
          />
        </LazyComponent>
      ),
      queryString: 'sales-channels',
    },
    {
      label: translate('Devices') as string,
      component: (
        <LazyComponent>
          <RMSPage
            pageLayoutEnabled={false}
            subscription={RMSSubscriptions.BASE}
            title={translate('Devices')}
            module={RMSModules.STATIONS}
            url={`configurations/system/${RMSModules.STATIONS}`}
            includePropertyIdInUrl
          />
        </LazyComponent>
      ),
      queryString: 'devices',
    },
  ];

  const getPageTitleAndCaption = () => {
    if (marketplaceType === SalesChannelType.UBER_EATS) {
      return {
        title: translate('Uber_Eats'),
        caption: translate('Uber_Eats_description'),
      };
    }
    if (marketplaceType === SalesChannelType.JUST_EATS) {
      return {
        title: translate('Just_Eat'),
        caption: translate('Just_Eat_description'),
      };
    }
    if (marketplaceType === SalesChannelType.DELIVEROO) {
      return {
        title: translate('Deliveroo'),
        caption: translate('Deliveroo_description'),
      };
    }

    return {
      title: translate('Marketplaces'),
      caption: '',
    };
  };

  return (
    <PageLayout
      documentTitle="Marketplaces"
      title={getPageTitleAndCaption().title}
      caption={getPageTitleAndCaption().caption}
    >
      <Tabs tabItems={tabItems} />
    </PageLayout>
  );
};

type MappedState = ReturnType<typeof mapStateToProps>;
const mapStateToProps = (state) => ({
  translate: getTranslate(state?.locale),
  selectedProperty: state.rms?.selectedProperty,
  currentApp: state.currentApp,
});
export default connect(mapStateToProps)(MarketPlacesPage);
